var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/lock-open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M12 1C13.933 1 15.5 2.567 15.5 4.5V7C15.5 7.27614 15.2761 7.5 15 7.5C14.7239 7.5 14.5 7.27614 14.5 7V4.5C14.5 3.11929 13.3807 2 12 2C10.6193 2 9.5 3.11929 9.5 4.5V6.5C10.6046 6.5 11.5 7.39543 11.5 8.5V13C11.5 14.1046 10.6046 15 9.5 15H2.5C1.39543 15 0.5 14.1046 0.5 13V8.5C0.5 7.39543 1.39543 6.5 2.5 6.5H8.5V4.5C8.5 2.567 10.067 1 12 1Z",
    fill: "#DC143C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnlock);
export default __webpack_public_path__ + "static/media/ic_unlock.b756854ec8be9ad4127153b3842cf4d2.svg";
export { ForwardRef as ReactComponent };